'use strict';
const	StoreFactory	= require('factories/Store');

module.exports = StoreFactory.create({
	displayName : 'Registration',
	actions : [
		'register',
		'promotional_newsletter'
	],
	reducer : function(state,action) {
		switch(action.type) {
		case 'REGISTRATION_REGISTER' :
			return Object.assign({},state,action.payload)

		case 'REGISTRATION_TYPE' :
			return Object.assign({},state,{
				type : action.payload
			})

		case 'REGISTRATION_PROMOTIONAL_NEWSLETTER' :
			return Object.assign({},state,{
				promotionalNewsletter : action.payload
			})

		case 'REGISTRATION_CLEAR' :

			return Object.assign({},state,{
				fullName : '',
				email : '',
				password : '',
				socmedId : undefined,
				businessId : undefined,
				mobilePhone : undefined,
				promotionalNewsletter : true,
				type : 'basic'
			})

		default :
			return state || {
				fullName : '',
				email : '',
				password : '',
				socmedId : undefined,
				businessId : undefined,
				mobilePhone : undefined,
				promotionalNewsletter : true,
				type : 'basic'
			};
		}
	}
})



// WEBPACK FOOTER //
// providers/stores/Registration.js